import { Box, Dialog, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DialogBox = styled(Dialog)(({ theme }) => ({
  "& .MuiBackdrop-root": {
    background: "rgba(0, 0, 0, 0.8)",
  },
  "& .MuiPaper-root": {
    minWidth: 328,
    background: "#fff",
    padding: "32px 24px",
    boxSizing: "border-box",
    borderRadius: 16,
    gap: 24,
  },
}));

export const ActionBox = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: 25,
}));

// 다이얼로그 제목
export const TitleText = styled(Typography)(({ theme }) => ({
  "&.MuiTypography-root": {
    fontSize: "1.125rem",
    color: "#333",
    fontWeight: 700,
    lineHeight: "25.2px",
    textAlign: "center",
  },
}));

// 다이얼로그 내용 텍스트
export const TextStyle = styled(Typography)(({ theme, color }) => ({
  "&.MuiTypography-root": {
    fontSize: "0.875rem",
    color: color ? color : "#333",
    fontWeight: 400,
    lineHeight: "19.6px",
    textAlign: "center",
    marginTop: 10,
    whiteSpace: "pre-line",
  },
}));

// 기본 버튼 스타일
const BaseButton = styled(Button)(({ theme }) => ({
  "&.MuiButtonBase-root": {
    minWidth: 136,
    padding: 16,
    borderRadius: 8,
    boxSizing: "border-box",
    color: "#333",
    fontSize: "0.875rem",
    lineHeight: "19.6px",
    fontWeight: 400,
    textTransform: "none",
  },
}));

// 취소 버튼 (왼쪽)
export const LeftButtonStyle = styled(BaseButton)(({ theme }) => ({
  "&.MuiButtonBase-root": {
    background: "#fff",
    outline: "1px solid #C9C9CA",
    marginRight: 8,
    "&:hover": {
      background: "#fff",
    },
  },
}));

// 확인 버튼 (오른쪽)
export const RightButtonStyle = styled(BaseButton)(({ theme }) => ({
  "&.MuiButtonBase-root": {
    background: "#FDD751",
    "&.delete-dialog": {
      background: "#FE536B",
      color: "#fff",
    },
    "&:hover": {
      background: "#FDD751",
    },
  },
}));
